// import baseConfig from "./baseconfig.json";
const baseConfig = window.__BASE_CONFIG__ || {};

const host = window.location.protocol + "//" + window.location.host;

// const domainMapping = baseConfig.domainMapping;

// const currentFlavor =
//   Object.keys(domainMapping).find((key) =>
//     domainMapping[key].some((domain) => host.includes(domain))
//   ) || "default";

const currentFlavor = baseConfig.currentFlavor || "default";
// console.log("Current Flavor:", currentFlavor);

const selectedConfig = baseConfig.flavors || {};

const googlemapKey = localStorage.getItem("mapKey");


const conf = {
  ...baseConfig.common,
  ...selectedConfig,
  fleetURL: selectedConfig.url + "/public/fleet",
  baseURL: selectedConfig.url + "/app/",
  fleetURLAdvertise: selectedConfig.url + "/public/fleet/",
  NodeUrl: selectedConfig.NodeCoreUrl,
  reportUrl: "http://172.31.43.85:5000/",
  reportUrl2: "https://dolphin.trackeazy.com",
  reportUrl3: "https://www.awtltrack.com/",
  excelUrl: "http://localhost:3076",
  currentFlavor: currentFlavor
};

export default conf;
